export var APP_NAME = '{yourAppName}';
export var USER_NAME = '{userName}';
export var TENANT = '{yourTenant}';
export var NAMESPACE = '{yourDomain}';
export var CLIENT_ID = '{yourClientId}';
export var CLIENT_SECRET = '{yourClientSecret}';
export var CALLBACK = '{https://yourApp/callback}';
export var API_IDENTIFIER = '{yourApiIdentifier}';
export var CONNECTION_NAME = '{yourConnectionName}';
